import { Col, message, PageHeader, Row, Select, Space, Spin, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  RangePickerItem,
  InputNumberItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import {
  descargarExcel,
  descargarPdf,
  UMBRAL_ALTO,
  UMBRAL_MEDIO,
} from "./exportarCostoVsUltimaCompra";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

const COLOR_ALTO = "#A8071A";
const COLOR_MEDIO = "#D46B08";
const COLOR_NEUTRO = "#595959";

/** Un insumo sin costo en el catalogo es el caso mas urgente, no el mas neutro. */
const colorDesviacion = (diferenciaPct) => {
  if (diferenciaPct === null || diferenciaPct === undefined) return COLOR_ALTO;
  const magnitud = Math.abs(diferenciaPct);
  if (magnitud >= UMBRAL_ALTO) return COLOR_ALTO;
  if (magnitud >= UMBRAL_MEDIO) return COLOR_MEDIO;
  return COLOR_NEUTRO;
};

const sorterTexto = (campo) => (a, b) =>
  (a[campo] || "").toString().localeCompare((b[campo] || "").toString());

const sorterNumero = (campo) => (a, b) => (a[campo] || 0) - (b[campo] || 0);

const ETIQUETA_DIRECCION = {
  1: "Solo donde compramos mas caro que el catalogo",
  2: "Solo donde compramos mas barato que el catalogo",
};

/**
 * Reporte Costo Vs Ultima Compra.
 *
 * Pone lado a lado `Insumo.costo` (ya convertido a MXN) y el costo de la ultima
 * entrada de compra del insumo, para cazar los costos de catalogo que se
 * quedaron viejos. La tabla en pantalla muestra lo esencial; el Excel trae el
 * detalle completo (codigo, marca, moneda, numero de compras, costo promedio y
 * la fecha del ultimo recalculo del costo).
 */
class ReporteCostoVsUltimaCompra extends Component {
  state = {
    loading: false,
    datos: [],
    resumen: {},
    bloquearCosto: false,
    consultado: false,
    filtros: {},
    objetoProyectos: null,
    objetoUnidadesDeNegocio: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    // En paralelo: son dos catalogos independientes y en serie solo alargan la
    // primera pintada del reporte.
    await Promise.all([
      axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoProyectos: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              )),
            });
          }
        }),
      axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoUnidadesDeNegocio: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              )),
            });
          }
        }),
    ]).catch(() => {
      message.error("Error de conexion");
    });
    this.consultarReporte();
  }

  consultarReporte(values = {}) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteCostoVsUltimaCompra",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            consultado: true,
            datos: res.data.datos || [],
            resumen: res.data.resumen || {},
            bloquearCosto: !!res.data.bloquearCosto,
            filtros: values,
          });
        } else if (res.data.success === 0 && res.data.message) {
          message.error(res.data.message);
          this.setState({ loading: false });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error de conexion");
        this.setState({ loading: false });
      });
  }

  descripcionFiltros() {
    const filtros = this.state.filtros || {};
    const partes = [];
    if (filtros.periodo && filtros.periodo[0] && filtros.periodo[1]) {
      partes.push(
        `Compras del ${moment(filtros.periodo[0]).format("DD/MM/YYYY")} al ${moment(
          filtros.periodo[1]
        ).format("DD/MM/YYYY")}`
      );
    } else {
      partes.push("Ultima compra historica");
    }
    if (filtros.filtrarProyecto === 1) {
      partes.push(`${(filtros.proyectos || []).length} proyecto(s)`);
    }
    if (filtros.filtrarProyecto === 2) {
      partes.push("Filtrado por unidad de negocio");
    }
    if (filtros.desviacionMinima) {
      partes.push(`Desviacion minima ${filtros.desviacionMinima}%`);
    }
    if (ETIQUETA_DIRECCION[filtros.direccion]) {
      partes.push(ETIQUETA_DIRECCION[filtros.direccion]);
    }
    return partes.join(" - ");
  }

  parametrosExportacion() {
    return {
      datos: this.state.datos,
      resumen: this.state.resumen,
      empresaNombre: this.props.empresa,
      descripcionFiltros: this.descripcionFiltros(),
    };
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "claveInsumo",
        key: "claveInsumo",
        width: "7%",
        sorter: sorterTexto("claveInsumo"),
        buscar: ["claveInsumo", "codigoInsumo"],
        ellipsis: true,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        width: "15%",
        sorter: sorterTexto("descripcionInsumo"),
        buscar: "descripcionInsumo",
        ellipsis: true,
      },
      {
        title: "Familia",
        dataIndex: "nombreFamilia",
        key: "nombreFamilia",
        width: "7%",
        sorter: sorterTexto("nombreFamilia"),
        buscar: "nombreFamilia",
        ellipsis: true,
      },
      {
        title: "Unidad",
        dataIndex: "nombreUnidad",
        key: "nombreUnidad",
        width: "5%",
        ellipsis: true,
      },
      {
        title: "Costo Catalogo",
        dataIndex: "costoCatalogo",
        key: "costoCatalogo",
        width: "8%",
        align: "right",
        sorter: sorterNumero("costoCatalogo"),
        // En la moneda del insumo; la comparacion va contra "Costo Cat. MXN".
        render: (value, record) => (
          <span title={`Moneda del insumo: ${record.abreviacionMoneda}`}>
            {dineroDisabledMask(value)} {record.abreviacionMoneda}
          </span>
        ),
      },
      {
        title: "T.C.",
        dataIndex: "tipoDeCambio",
        key: "tipoDeCambio",
        width: "5%",
        align: "right",
        sorter: sorterNumero("tipoDeCambio"),
        render: (value, record) =>
          value === null || value === undefined ? (
            "-"
          ) : (
            <span title={`Origen: ${record.origenTipoDeCambio}`}>{value}</span>
          ),
      },
      {
        title: "Costo Cat. MXN",
        dataIndex: "costoCatalogoMxn",
        key: "costoCatalogoMxn",
        width: "8%",
        align: "right",
        sorter: sorterNumero("costoCatalogoMxn"),
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Ultimo Costo Compra",
        dataIndex: "ultimoCosto",
        key: "ultimoCosto",
        width: "8%",
        align: "right",
        sorter: sorterNumero("ultimoCosto"),
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Diferencia",
        dataIndex: "diferencia",
        key: "diferencia",
        width: "8%",
        align: "right",
        sorter: sorterNumero("diferencia"),
        render: (value, record) => (
          <span style={{ color: colorDesviacion(record.diferenciaPct), fontWeight: 500 }}>
            {dineroDisabledMask(value)}
          </span>
        ),
      },
      {
        title: "Dif. %",
        dataIndex: "diferenciaPct",
        key: "diferenciaPct",
        width: "6%",
        align: "right",
        // Los de porcentaje nulo (catalogo en 0) se van al tope de la lista.
        sorter: (a, b) => {
          if (a.diferenciaPct === null && b.diferenciaPct === null) return 0;
          if (a.diferenciaPct === null) return 1;
          if (b.diferenciaPct === null) return -1;
          return Math.abs(a.diferenciaPct) - Math.abs(b.diferenciaPct);
        },
        render: (value) => (
          <span style={{ color: colorDesviacion(value), fontWeight: 500 }}>
            {value === null || value === undefined ? "-" : `${value}%`}
          </span>
        ),
      },
      {
        title: "Ultima Compra",
        dataIndex: "fechaUltimaCompra",
        key: "fechaUltimaCompra",
        width: "8%",
        align: "center",
        sorter: (a, b) =>
          moment(a.fechaUltimaCompra).valueOf() - moment(b.fechaUltimaCompra).valueOf(),
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
      },
      {
        title: "Dias",
        dataIndex: "diasDesdeUltimaCompra",
        key: "diasDesdeUltimaCompra",
        width: "4%",
        align: "right",
        sorter: sorterNumero("diasDesdeUltimaCompra"),
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        width: "9%",
        sorter: sorterTexto("proveedor"),
        buscar: "proveedor",
        ellipsis: true,
      },
      {
        title: "Documento",
        dataIndex: "documento",
        key: "documento",
        width: "6%",
        buscar: "documento",
        ellipsis: true,
      },
      {
        // Ultima compra menos fecha de calculo del costo: positivo es mercancia
        // que ya entro y cuya factura aun no actualiza el catalogo.
        title: "Dias Desv.",
        dataIndex: "diasDesviacion",
        key: "diasDesviacion",
        width: "5%",
        align: "right",
        sorter: sorterNumero("diasDesviacion"),
        render: (value) => (value === null || value === undefined ? "-" : value),
      },
    ];

    const resumen = this.state.resumen || {};

    return (
      <Form
        name="reporteCostoVsUltimaCompra"
        onFinish={this.consultarReporte.bind(this)}
        onFinishFailed={this.onFinishFailed}
      >
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            "Reporte Costo Vs Ultima Compra" +
            (this.state.consultado
              ? `: ${resumen.insumosMostrados || 0} de ${resumen.insumosAnalizados || 0} insumos`
              : "")
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", justifyContent: "right" }}>
              <Space>
                {this.state.datos.length > 0 && (
                  <ButtonItem
                    blanco
                    onClick={() => descargarExcel(this.parametrosExportacion())}
                    icon={<FileExcelOutlined />}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Descargar Excel
                  </ButtonItem>
                )}
                {this.state.datos.length > 0 && (
                  <ButtonItem
                    blanco
                    onClick={() => descargarPdf(this.parametrosExportacion())}
                    icon={<FilePdfOutlined />}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Descargar PDF
                  </ButtonItem>
                )}
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Consultar
                </ButtonItem>
              </Space>
            </div>
          }
        />
        <Spin spinning={this.state.loading}>
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 5,
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Tabs
              style={{ margin: 0 }}
              tabBarExtraContent={{
                left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
              }}
            >
              <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                <FormItem
                  marginBottom="0px"
                  label="Periodo de compras"
                  name="periodo"
                  tooltip="Deja este campo vacio para tomar la ultima compra historica de cada insumo. Con un periodo, solo se consideran las compras de ese rango."
                >
                  <RangePickerItem />
                </FormItem>
              </TabPane>
              <TabPane tabKey="2" key="2" forceRender tab="Proyecto">
                <Row>
                  <Col span={8}>
                    <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                      <SelectItem width="90%" placeholder="Filtrar Proyecto">
                        <Option default value={0}>
                          Niguno
                        </Option>
                        <Option value={1}>Proyectos</Option>
                        <Option value={2}>Unidades de negocio</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const filtrarProyecto = getFieldValue("filtrarProyecto");
                        if (filtrarProyecto === 1) {
                          return (
                            <FormItem required name="proyectos" margin noStyle>
                              <SelectItem
                                width="90%"
                                placeholder="Proyectos"
                                mode="multiple"
                              >
                                {this.state.objetoProyectos}
                              </SelectItem>
                            </FormItem>
                          );
                        }
                        if (filtrarProyecto === 2) {
                          return (
                            <FormItem required margin name="unidadDeNegocioId" noStyle>
                              <SelectItem width="90%" placeholder="Unidades de Negocio">
                                {this.state.objetoUnidadesDeNegocio}
                              </SelectItem>
                            </FormItem>
                          );
                        }
                      }}
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabKey="3" key="3" forceRender tab="Desviacion">
                <Row>
                  <Col span={8}>
                    <FormItem
                      label="Desviacion minima"
                      name="desviacionMinima"
                      margin
                      tooltip="Solo muestra los insumos donde la diferencia entre el costo del catalogo y la ultima compra es de al menos este porcentaje. Los insumos sin costo en el catalogo se muestran siempre."
                    >
                      <InputNumberItem porcentaje min={0} max={1000} />
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label="Direccion" name="direccion" margin initialValue={0}>
                      <SelectItem width="90%" placeholder="Direccion">
                        <Option value={0}>Todas</Option>
                        <Option value={1}>Compramos mas caro</Option>
                        <Option value={2}>Compramos mas barato</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </div>
          <div style={{ height: 10 }} />
          <div style={{ backgroundColor: "white", padding: 20, borderRadius: 5 }}>
            {this.state.consultado && (
              <p style={{ color: COLOR_NEUTRO, marginBottom: 10 }}>
                {`Compramos mas caro que el catalogo: ${resumen.comprandoMasCaro || 0} - `}
                {`Compramos mas barato: ${resumen.comprandoMasBarato || 0} - `}
                {`Desviacion promedio: ${resumen.desviacionPromedio || 0}%`}
                {this.state.bloquearCosto
                  ? " - La empresa tiene el costo bloqueado, asi que las compras no actualizan el costo del catalogo."
                  : ""}
              </p>
            )}
            <TableItem
              size="small"
              dataSource={this.state.datos}
              columns={columns}
              rowKey={(value) => value.insumoId.toString()}
            />
          </div>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresa: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteCostoVsUltimaCompra);
